import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { StickyHeader } from '../../components'
import { generateMonthPicker } from '../../utils'
import { MobileFilterToggle } from '../../components/search'
import {
  filtersToClean,
  filtersKeys,
} from './search-parameters/group-trips-parameters'
import { setNumberOfTrips } from '../../actions/search-actions'
import {
  searchFiltersHook,
  searchOnInitHook,
} from '../../components/search/hooks'
import { TripItem, FiltersGroup } from '../../components/search-group'

const monthes = generateMonthPicker()

function GroupTripsSearch({
  pk,
  model,
  title,
  resortDetails,
  searchFilters,
  inTitle,
  numberOfTrips,
  setNumberOfTrips,
  isWidget,
  filters,
  trustpilotLocale,
}) {
  const {
    transformedFilters,
    filtersCount,
    updateParams,
    triggerApi,
    clearSelectedFilters,
    clearDates,
  } = searchFiltersHook(filtersKeys, filtersToClean)
  searchOnInitHook(filtersKeys, 'liveaboard')

  return (
    <div className='search-page-la search-group-trip'>
      <StickyHeader locationTitle={title} typeOfSearch='group-trips' />
      <ReactTooltip type='dark' effect='solid' id='global' />
      <div className='search-wrapper'>
        <div className='main-content'>
          <h1 className='hidden-xs'>
            <FormattedMessage
              id='search.title.group_trip'
              values={{
                qty: numberOfTrips,
                location: inTitle,
              }}
              defaultMessage='{ qty, plural, one {# group trip} other {# group trips }} { location }'
            />
          </h1>
          <FiltersGroup
            triggerApi={triggerApi}
            resortDetails={resortDetails}
            monthes={monthes}
            isWidget={isWidget}
            selectedFilters={searchFilters}
            items={filters}
            title={title}
            updateParams={updateParams}
            clearDates={clearDates}
            clearSelectedFilters={clearSelectedFilters}
            trustpilotLocale={trustpilotLocale}
            filtersCount={filtersCount}
            model={model}
            groupTrips
            pk={pk}
          />
          <div className='result-list'>
            <div className='results-head'>
              <div className='results-actions'>
                <MobileFilterToggle filtersCount={filtersCount} />
              </div>
            </div>
            {
              <TripItem
                setNumberOfItems={setNumberOfTrips}
                selectedParams={transformedFilters}
                getNewData={triggerApi}
                model={model}
                pk={pk}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    numberOfTrips: state.numberOfTrips,
    pageLoader: state.pageLoader,
    isNearBy: state.isNearBy,
    searchFilters: state.searchFilters,
  }),
  { setNumberOfTrips }
)(GroupTripsSearch)
